/** 
 * converts a pixel, point or box into a point feature with lon/lat attributes
 */

import ol = require("ol");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

// this command triggers one or more events, see base-command for rules
class Command extends Base<any> {

    static about = `
Converts a pixel, point or box into a point feature with lon/lat attributes.

Usage Example:

    <EVENT about="Adds a feature to the map every time the user clicks on a non-feature (features are after every click so this has to happen last)" disabled="False" event="show-click-location" id="show-click-location-handler" mid="app/commands/create-point-feature">
    <OPTIONS>
        <Values about="Renders the click location as a point on the points layer" id="event" value="add-to-points-layer" />
        <Values id="symbology" value="points" />
        <Values id="debug" value="false" />
    </OPTIONS>
    </EVENT>

`;

    static input = {
        "box": "geometric extent"
    };

    static output = {
        "layers": "layer containing single feature with 'lon' and 'lat' values"
    };

    execute(args: any = this.args) {
        let box = this.findArg("box", this).box;
        if (!box) return;
        let center = ol.extent.getCenter(box);
        let layer = {
            features: [{
                geometry: center,
                geometryType: "point",
                attributes: {
                    lon: center[0],
                    lat: center[1]
                }
            }]
        };

        this.trigger({layers: [layer]});
    }

}

export = Command; 